import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import AiCoachCard from '../../../components/ai/AiCoachCard'
import {
  fetchMealContext,
  buildMealCoachPrompt,
} from '../../../lib/ai/mealCoachPrompt'

// Last 14 days of meal logs → coach note from Gemini. Same shell as
// the workout coach; only the data + prompt builder differ.
export default function MealCoach() {
  const { i18n } = useTranslation()
  const buildPrompt = useCallback(async ({ user }) => {
    const context = await fetchMealContext(user.id)
    return { prompt: buildMealCoachPrompt(context, i18n.language === 'ar' ? 'ar' : 'en') }
  }, [i18n.language])

  return <AiCoachCard kind="meal_coach" i18nKey="mealCoach" buildPrompt={buildPrompt} />
}
